import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 1.261c-8.141 0-14.738 6.597-14.738 14.74 0 8.141 6.597 14.738 14.739 14.738S30.739 24.142 30.739 16 24.143 1.261 16.001 1.261Zm7.24 10.098-2.42 11.398c-.178.809-.66 1.005-1.33.624l-3.686-2.716-1.777 1.712c-.196.196-.362.363-.742.363l.261-3.75 6.829-6.17c.297-.261-.066-.41-.458-.148l-8.44 5.313-3.636-1.135c-.79-.25-.809-.79.166-1.17l14.21-5.48c.66-.238 1.236.16 1.022 1.159Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "telegram"}) } }